module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_42.99655ddc.jpg";